module.exports = __webpack_public_path__ + "static/graph2-9f87beb97fb28fcdd9effb7edef6a371.png";